/** Status labels and StatusIndicator mapping, shared by every surface. */

import React from 'react';
import StatusIndicator, {
  StatusIndicatorProps,
} from '@amzn/awsui-components-core/status-indicator';
import { ActionItemStatus } from 'src/types/actionItems.types';

/** Display labels for the canonical status vocabulary. */
export const STATUS_LABELS: Record<ActionItemStatus, string> = {
  OPEN: 'Open',
  IN_PROGRESS: 'In progress',
  BLOCKED: 'Blocked',
  DONE: 'Done',
  CANCELLED: 'Cancelled',
};

/** Cloudscape indicator semantics per status. */
const STATUS_TYPES: Record<ActionItemStatus, StatusIndicatorProps.Type> = {
  OPEN: 'pending',
  IN_PROGRESS: 'in-progress',
  BLOCKED: 'warning',
  DONE: 'success',
  CANCELLED: 'stopped',
};

export const ActionItemStatusIndicator: React.FC<{
  status: ActionItemStatus;
}> = ({ status }) => (
  <StatusIndicator type={STATUS_TYPES[status]}>
    {STATUS_LABELS[status]}
  </StatusIndicator>
);
